import UnitInterface from "./UnitInterface";

export default class NumberUnit implements UnitInterface {
  private number: number;

  constructor(number: number) {
    this.number = number;
  }
  
  toValue(): number {
    return this.number;
  }
}